import { createEntityActions, createListActions } from '@aston/foundation';
import { createAction, props } from '@ngrx/store';
import { IFilter, ActionType } from '@aston/foundation';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IFederationForm, IFederationUser, IFederationUsersList } from 'apps/console/src/app/federations-module/models';
import { FederationUsersListSortProp } from 'apps/console/src/app/federations-module/enums';
import { UserStatus } from '@aston/middle-users-admin';

const ActionPrefix = 'FederationDetail';

export const ToggleIsEditingFederation = createAction(`[${ActionPrefix}] Toggle Is Editing Federation`);

export const SetActiveModal = createAction(`[${ActionPrefix}] SetActiveModal`, props<{ modal: NgbModalRef }>());

export const OpenFederationUserForm = createAction(`[${ActionPrefix}] OpenFederationUserForm`);

export const OpenUserDelegationView = createAction(`[${ActionPrefix}] OpenUserDelegationView`, props<{ user: IFederationUser }>());

export const OpenUserDelegationForm = createAction(`[${ActionPrefix}] OpenUserDelegationForm`, props<{ user: IFederationUser, currentUser: IFederationUser, mode: ActionType }>());

export const DisplayEmailAlreadyExistInGuestListError = createAction(`[${ActionPrefix}] Display Email Already Exist In Guest List Error`);

export const DisplayEmailAlreadyExistInUserListError = createAction(`[${ActionPrefix}] Display Email Already Exist Error`);

export const createFederationUserActions = createEntityActions<any>(ActionPrefix, 'Create Federation user');
export const {
	CreateEntityRequest: CreateFederationUserRequest,
	CreateEntitySuccess: CreateFederationUserSuccess,
	CreateEntityFailure: CreateFederationUserFailure,
} = createFederationUserActions;

export const currentFederationActions = createEntityActions<IFederationForm>(ActionPrefix, 'Current Federation');
export const {
	LoadEntityByIdRequest: LoadFederationRequest,
	LoadEntitySuccess: LoadFederationSuccess,
	LoadEntityFailure: LoadFederationFailure,
	UpdateEntityRequest: UpdateFederationRequest,
	UpdateEntitySuccess: UpdateFederationSuccess,
	UpdateEntityFailure: UpdateFederationFailure
} = currentFederationActions;


export const usersListActions = createListActions<IFederationUsersList, FederationUsersListSortProp, IFilter>(ActionPrefix, 'Users List');
export const {
	LoadListRequest: LoadUsersListRequest,
	LoadListSuccess: LoadUsersListSuccess,
	LoadListFailure: LoadUsersListFailure,
	ListSettings: UpdateUsersListSettings,
} = usersListActions;

export const updateTransientUserStatusActions = createEntityActions<{ userId: number, userStatus: UserStatus, wasDelegating?: boolean, wasDelegated?: boolean }>(ActionPrefix, 'Update TransientUserStatus');
export const {
	UpdateEntityRequest: UpdateTransientUserStatusRequest,
	UpdateEntitySuccess: UpdateTransientUserStatusSuccess,
	UpdateEntityFailure: UpdateTransientUserStatusFailure
} = updateTransientUserStatusActions;

export const ResentUserInvitationActions = createEntityActions<{ userId: number}>(ActionPrefix, 'Resent User Invitation');
export const {
	UpdateEntityRequest: ResentUserInvitationRequest,
	UpdateEntitySuccess: ResentUserInvitationSuccess,
	UpdateEntityFailure: ResentUserInvitationtFailure
} = ResentUserInvitationActions;
